export default {
  appointmentContainer: {
    title: 'Planen Sie die Reparatur',
    text: 'Unsere Reparateure sind zu den folgenden Creneaxus verfügbar.',
    text2: 'Diese Fransen entsprechen der erwarteten Ankunftszeit des Fachmanns.',
    actions: {
      primary: 'Uhrzeit bestätigen',
      secondaryHelpText: 'Passt Ihnen keine dieser Zeiten?',
      secondary: 'Ich möchte zurückgerufen werden'
    },
    dates: {
      months: {
        january: 'Januar',
        february: 'Februar',
        march: 'März',
        april: 'April',
        may: 'Mai',
        june: 'Juni',
        july: 'Juli',
        august: 'August',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'Dezember'
      }
    },
    notifications: {
      errors: {
        getSchedule: 'Ein Fehler ist aufgetreten! Es war nicht möglich, die verfügbaren Tage für die Terminvereinbarung abzurufen.',
        postAppointment: 'Fehler! Der ausgewählte Termin konnte nicht geplant werden.',
        postContact: 'Fehler! Der Kontakt konnte nicht angefordert werden.'
      }
    }
  }
}
